import { Col, Row } from "antd";
import {
  InputField,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../../../components";
import styles from "./Menu.module.css";
import { useEffect, useState } from "react";
import Modal from "../../../../../components/modal/Modal";
import { AiOutlinePlus } from "react-icons/ai";
import { useRef } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { EventPlanningMiddleware } from "../../../../../Store/Middlewares/EventPlanningMiddleware";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";

const menuItems = [
  {
    name: "Barbeque",
    desc: "Savor the smoky goodness with our expertly grilled barbeque selection, from tender ribs to succulent pulled Cow. Each bite is a journey into the heart of grilling perfection.",
  },
  {
    name: "Chicken",
    desc: "Our chicken dishes are a symphony of flavors, whether it's the juicy grilled pieces or the saucy, savory creations.",
  },
  {
    name: "Beef",
    desc: "Indulge in the rich tenderness of our premium beef selections, from marinated steaks to slow-cooked briskets.",
  },
  {
    name: "Kids Meal",
    desc: "Our specially curated kids' meals, from mini burgers to crispy chicken tenders, offer a balanced blend of flavors",
  },
  {
    name: "Lamb",
    desc: "Discover the succulent tenderness of our lamb dishes, carefully seasoned and cooked to perfection.",
  },
];

const MenuModal = ({ setMenu, setModalOpen }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const {state} = useLocation();
  const dispatch = useDispatch();
  const event_id = state?.eventData?.id;
  // const item = useRef();

  // const handleChange = (e, title) => {
  //   item.current = { ...item.current, [title]: e.target.value };
  // };
  const CreateMenu = () => {
    if (!name || !description) {
      dispatch(showAlert({
        type: "Error",
        message: "All fields are required!"
      }))
    } else {
        dispatch(EventPlanningMiddleware.createEventMenu({ id: event_id, name: name, des: description }))
            .then(() => { setModalOpen(false); setMenu(""); setDescription("")})
            .catch(() => {setModalOpen(false); setMenu(""); setDescription("")})
    }
  }
  // const handleClick = () => {
  //   // setMenu((prev) => [...prev, item?.current]);
  //   setModalOpen(false);
  // };
  return (
    <>
      <Row>
        <TextComponent textClass={styles.modalTitle}>Add Menu</TextComponent>
      </Row>
      <Row>
        <Col xs={24}>
          <InputField
            label="Menu Name"
            placeholder="Fish"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextareaField
            label="Menu Description"
            value={description}
            placeholder="Experience the exquisite flavors of our freshly caught fish dishes, expertly seasoned and prepared to perfection."
            onChange={(e) => setDescription(e.target.value)}
          />
          <SubmitButton
            title="Save Menu"
            btnClass={styles.modalBtn}
            onClick={CreateMenu}
          />
        </Col>
      </Row>
    </>
  );
};

const Menu = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [menu, setMenu] = useState(menuItems);
  const {state} = useLocation();
  const dispatch = useDispatch();
  const event_id = state?.eventData?.id;
  const Menu = useSelector(state => state.EventPlanningReducer.Menu);

  useEffect(() => {
    dispatch(EventPlanningMiddleware.eventMenus({ id: event_id }))
}, [])


  return (
    <>
      <Row className={styles.headingRow}>
        <Col xs={24} sm={6}>
          <TextComponent textClass={styles.headingText}>Menu</TextComponent>
        </Col>
        <Col xs={24} sm={6} md={5} lg={4}>
          <SubmitButton
            title={"+ Add Menu"}
            btnClass={styles.btn}
            outline={true}
            onClick={() => setModalOpen(true)}
          />
        </Col>
      </Row>
      <Row gutter={[24, 16]} className={styles.itemsRow}>
        {Menu?.map((item) => (
          <Col xs={24} md={12}>
            <div className={styles.menuItem}>
              <Row className={styles.nameRow}>
                <TextComponent textClass={styles.itemName}>
                  {item.name}
                </TextComponent>
              </Row>
              <Row className={styles.descRow}>
                <TextComponent textClass={styles.itemDesc}>
                  {item.description}
                </TextComponent>
              </Row>
            </div>
          </Col>
        ))}
      </Row>
      {modalOpen && <Modal
        isModalOpen={modalOpen}
        setIsModalOpen={setModalOpen}
        closable={true}
        // pinkBg={true}
        // wideModal={true}
        className={styles.modalContent}
      >
        <MenuModal setMenu={setMenu} setModalOpen={setModalOpen} />
      </Modal>}
    </>
  );
};

export default Menu;
